/* import "./index.scss"; */
import { __ } from '@wordpress/i18n';
import { TextControl } from "@wordpress/components";
import { useBlockProps } from "@wordpress/block-editor";
import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";

registerBlockType(metadata.name, {...metadata, edit: EditComponent, });

function EditComponent(props) {

    const {attributes, setAttributes}= props;
	const {categoria} = attributes;

    return (
        <>
            <div {...useBlockProps()}>
                <h3>Swiper de Produtos</h3>
                <h4>
                    <TextControl
						label={('Indique a categoria dos produtos a listar:')}
						value={categoria}
						onChange={(e) => setAttributes({categoria: e})}
					/>
                </h4>
                <p><span style={{ fontSize: '0.9em'}}>Se quiser listar os destaques escreva: </span>
                <span style={{ fontSize: '1em', fontWeight: 'bold' }}>Destaques</span></p>
            </div>
        </>
    );
}